var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barrages-drop"},[_c('vue-baberrage',{attrs:{"barrageList":_vm.barrageList,"boxHeight":_vm.boxHeight,"isShow":_vm.barrageIsShow,"lanesCount":_vm.lanesCount,"loop":_vm.barrageLoop,"messageHeight":_vm.messageHeight,"throttleGap":_vm.throttleGap}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }